import { restartEHRFlow } from 'api/User/api';
import { RESTART_EHR_FLOW } from 'store/users/types';

import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export const useRestartHGFlow = (finalCallback: () => void) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [ isLoading, setIsLoading ] = useState(false);
  const [ error, setError ] = useState<string>();

  const restartFlow = useCallback((userId: number) => {
    setIsLoading(true);
    setError('');

    restartEHRFlow(userId)
      .then(() => {
        dispatch({ type: RESTART_EHR_FLOW, data: { userId } });
      })
      .catch(error => setError(error?.response?.data?.message || t('errors.server_error_try_again')))
      .finally(() => {
        setIsLoading(false);
        finalCallback();
      });
  }, [ t, dispatch, finalCallback ]);

  return {
    restartFlow,
    isLoading,
    error,
  };
};
